<ion-item [disabled]="disabledField" [ngClass]="{'gl-disable-invisible': disabledField && !looksDisabled, 'item-disabled': (field.readonly ?? 0) | readonlyByRule: etatId}">
  <ion-toggle class="gl-style-checkbox-html-label" color="success" [formControl]="cFormControl" [disabled]="disabledField || ((field.readonly ?? 0) | readonlyByRule: etatId)">
    <div [innerHtml]="field.label | fetchImageFromHtmlPipe:field['images'] | async | trustHtmlPipe" *ngIf="!noLabel">
    </div>
    &nbsp;
  </ion-toggle>
</ion-item>
